import { createSelector } from 'reselect';

const selectAccountUsers = (state: any) => state.accountUsers;


export const selectAccountUsersCurrentItem = createSelector([selectAccountUsers], (accountUsers) => accountUsers.current);

export const selectAccountUsersListItems = createSelector([selectAccountUsers], (accountUsers) => accountUsers.list);

export const selectAccountUsersItemById = (itemId: any) =>
    createSelector(selectAccountUsersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAccountUsersQueryItems = createSelector([selectAccountUsers], (accountUsers) => accountUsers.query);

export const selectAccountUsersCreatedItem = createSelector([selectAccountUsers], (accountUsers) => accountUsers.create);

export const selectAccountUsersUpdatedItem = createSelector([selectAccountUsers], (accountUsers) => accountUsers.update);

export const selectAccountUsersReadItem = createSelector([selectAccountUsers], (accountUsers) => accountUsers.read);

export const selectAccountUsersDeletedItem = createSelector([selectAccountUsers], (accountUsers) => accountUsers.delete);

export const selectAccountUsersSearchedItems = createSelector([selectAccountUsers], (accountUsers) => accountUsers.search);

export const selectAccountUsersItemsCount = createSelector([selectAccountUsers], (accountUsers) => accountUsers.count);

export const selectAccountUsersItemsFilter = createSelector([selectAccountUsers], (accountUsers) => accountUsers.filter);